<div class="col-md-12">
    <!--<h2>BunnyCRM Action Items</h2>-->
    <p>BunnyCRM Action Items turns follow-ups into tracked tasks, so commitments made in a note, ticket, or
        deal don't get lost. Every action item has a clear owner, a due date, and a status your whole team
        can see — so "I'll get to it" turns into something you can actually track to done, without a
        separate task manager bolted onto your CRM.
    </p>
    <h3>Key Features</h3>
    <ul>
        <li><strong>Task Creation From Any Record:</strong> Turn a note, ticket, or deal into an action item in one step.</li>
        <li><strong>Assignment &amp; Due Dates:</strong> Every action item has a clear owner and deadline.</li>
        <li><strong>Status Tracking:</strong> See what's open, in progress, or done at a glance.</li>
        <li><strong>Kanban Board:</strong> Visualize action items as cards grouped by status, dragged from one column to the next as work moves.</li>
        <li><strong>Calendar View:</strong> See every action item by its due date alongside the rest of your schedule.</li>
        <li><strong>Notifications &amp; Reminders:</strong> Owners are notified as due dates approach or items are reassigned.</li>
        <li><strong>Cross-Team Visibility:</strong> Sales, marketing, and support all work off the same list of open commitments, tied to the record they belong to.</li>
    </ul>
</div>
